import { DEFAULT_LOCALE, type Locale, SUPPORTED_LOCALES } from '../types'

export function detectBrowserLanguage(): Locale {
  if (typeof navigator === 'undefined') {
    return DEFAULT_LOCALE
  }

  const languages = navigator.languages ?? [navigator.language]

  for (const lang of languages) {
    if (!lang) {
      continue
    }

    const baseLocale = lang.split('-')[0]?.toLowerCase()

    if (baseLocale && SUPPORTED_LOCALES.includes(baseLocale as Locale)) {
      return baseLocale as Locale
    }
  }

  return DEFAULT_LOCALE
}
